import { type StackProps, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import { getContainerSx } from './styles.ts';
export const BlurContainer = ({sx, ...rest}: StackProps) => {
  const theme = useTheme()
  return (
    <Stack
      sx={getContainerSx(theme, sx)}
      {...rest}
    />
  );
};
